import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { tokens } from '@companycam/slab-tokens';

import { ButtonPrimary, ButtonCancel, ButtonDestroy } from './buttons/Button';

const DismissOverlay = styled.div`
  pointer-events: initial;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(20, 35, 52, 0.85);
  width: 100%;
  height: 100%;
`;

const ModalTitle = styled.p`
  color: ${tokens.color_label_dark_gray};
  font-weight: 600;
  font-size: 24px;
  line-height: 1.25;
  margin: 0 0 16px 0;
  padding: 0;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif, Roboto, Helvetica Neue, Arial,
    sans-serif;
`;

const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${tokens.color_background_1_le};
  width: 600px;
  border-radius: 8px;
  box-shadow: 0 1px 6px rgba(58, 75, 86, 0.2);
  overflow: hidden;
`;
const RowBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 32px 16px 32px;
`;

const RowButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  background-color: #f2f5f8; //replace with Slab token
  padding: 16px;
`;

const TextMessage = styled.span`
  font-family: sans-serif;
  padding-bottom: 16px;
  color: ${tokens.color_text_default_le};
`;

const Modal = ({
  title,
  message,
  children,
  destructiveModal,
  onClickCancel,
  onClickPrimary,
  primaryButtonText,
  cancelButtonText,
}) => (
  <DismissOverlay onClick={onClickCancel}>
    <ModalContentWrapper
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <RowBody>
        <ModalTitle>{title}</ModalTitle>
        {message ? <TextMessage>{message}</TextMessage> : null}
        {children}
      </RowBody>
      <RowButtons>
        <ButtonCancel size="small" cancel addSpacing onClick={onClickCancel}>
          {cancelButtonText}
        </ButtonCancel>
        {destructiveModal ? (
          <ButtonDestroy size="small" addSpacing onClick={onClickPrimary}>
            {primaryButtonText}
          </ButtonDestroy>
        ) : (
          <ButtonPrimary size="small" addSpacing onClick={onClickPrimary}>
            {primaryButtonText}
          </ButtonPrimary>
        )}
      </RowButtons>
    </ModalContentWrapper>
  </DismissOverlay>
);

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  children: PropTypes.node,
  destructiveModal: PropTypes.bool,
  onClickCancel: PropTypes.func.isRequired,
  onClickPrimary: PropTypes.func.isRequired,
  primaryButtonText: PropTypes.string.isRequired,
  cancelButtonText: PropTypes.string.isRequired,
};

Modal.defaultProps = {
  message: null,
  children: null,
  destructiveModal: false,
};

export default Modal;
